import CsScrollbar from '../essentials/cs-scrollbar.js';

export default class Scroll {

  /**
   * Toggles the scrolling behavior of a specified element.
   * When activated, the element regains its normal scroll behavior.
   * When deactivated, vertical scrolling is hidden. If the element is the BODY,
   * additional styles are applied to prevent unintended layout shifts.
   *
   * @param {HTMLElement} el - The HTML element to modify scrolling for.
   * @param {boolean} [activate=true] - Determines whether scrolling should be enabled (true) or disabled (false).
   */
  static toggleScrollBehavior(el, activateScrolling = true) {
    if (!el) {
      return;
    }

    if (activateScrolling) {
      el.style.overflowY = 'visible';

      if (el.tagName === 'BODY') {
        el.style.position = 'initial';
        el.style.width = 'initial';

        const scrollY = parseInt(document.body.style.top || '0', 10) * -1;
        el.style.top = '';
        window.scrollTo(0, scrollY);
      }
    } else {
      el.style.overflowY = 'hidden';

      if (el.tagName === 'BODY') {
        el.style.position = 'fixed';
        el.style.width = '100%';

        const scrollY = window.scrollY;
        el.style.top = `-${scrollY}px`;
      }
    }

    CsScrollbar.setScrollbarScreenWidth();
  }

  /**
   * Sets the vertical overflow behavior of the element to 'auto'.
   *
   * This allows the element to scroll vertically if its content exceeds its height.
   *
   * @param {HTMLElement} el - The element to modify.
   */
  static setScrollBehaviorToAuto(el) {
    if (!el) {
      return;
    }

    el.style.overflowY = 'auto';

    CsScrollbar.setScrollbarScreenWidth();
  }
}
